import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import connect from 'react-redux/es/connect/connect'
import { bindActionCreators } from 'redux'
import NovaPoshta from 'novaposhta'

import Button from '../../components/Button/Button'
import SelectField from '../../components/SelectField'
import TextField from '../../components/TextField/TextField'

import { METHOD_OF_RECEIPT_KEYS, PAYMENT_METHODS, DELIVERY_METHODS, DELIVERY_METHODS_OPTIONS } from '../../constants/order.constants'
import { UKRAINE_PHONE_NUMBER_REG_EXP, EMAIL_REG_EXP } from '../../constants/regexp.constants'

import { login } from '../../db/User'
import { addToCart, changeCount, clearCart, removeFromCart } from '../../db/Cart'

import NovaPoshtaIcon from '../../icons/nova_poshta.jpeg'
import UkrPoshta from '../../icons/ukr_poshta.jpeg'
import MeestIcon from '../../icons/meest.jpeg'

import { httpPost } from '../../services/http'

import { useBrowserTab } from '../../hooks/useBrowserTab'

import './order.css'

const novaPoshta = new NovaPoshta({ apiKey: 'a8ca4da2a732fb0b8d7358713447ff82' })

const DEFAULT_STATE = {
	description: '',
	phone: '',
	name: '',
  lastName: '',
	username: '',
  email: '',
	np: [],
	opl: METHOD_OF_RECEIPT_KEYS.novaPoshta,
	dost: '',
	cities: [],
	city: '',
	desc: '',
	success: false,
	error: false,
	number: '',
  recipientPhone: '',
  recipientName: '',
  recipientLastName: '',
  paymentMethod: '',
  deliveryMethod: DELIVERY_METHODS.department,
}

const Order = (props) => {
  const { user, clearCart, cart } = props
	const [state, setState] = useState(DEFAULT_STATE)
  const [touched, setTouched] = useState({ phone: false, email: false })
  const {
    city,
    cities,
    dost,
    np,
    desc,
    opl,
    number,
    success,
    phone,
    name,
    lastName,
    email,
    deliveryMethod,
  } = state
  const submitDisabled = !dost || !opl || !name || !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP) || !lastName

  const setFieldTouched = (key, value) => {
    setTouched((prevState) => ({
      ...prevState,
      [key]: value
    }))
  }

	const updateState = (value) => {
		setState((prevState) => ({
			...prevState,
			...value,
		}))
	}

  useBrowserTab({ tabName: 'Замовлення' })

  useEffect(() => {
		if (user.logged) {
			setState((prevState) => ({
				...prevState,
				phone: user.phone,
				name: user.name,
				username: user.Name,
			}))
		}
		novaPoshta.address.getCities()
			.then((data) => {
				setState(prevState => ({
					...prevState,
					cities: data.data
				}))
			})
	}, [])

  const fetchWearehouses = (city) => {
		novaPoshta.address.getWarehouses({
			CityName: city
		})
			.then((data) => {
				setState((prevState) => ({
					...prevState,
					np: data.data
				}))
			})
	}

  const submit = () => {
		httpPost('order/create', {
			...state,
			cities: [],
			np: [],
      dost: dost === PAYMENT_METHODS.card ? 'Картами Visa, MasterCard' : 'Готівкою при отриманні',
      items: cart
		})
			.then((data) => {
				if (data) {
					setState((prevState) => ({
						...prevState,
						success: true,
						number: data._id,
					}))
					clearCart();
				} else {
					setState((prevState) => ({
						...prevState,
						error: true,
					}))
				}
			})
	}

  const isCompletedSection = (list = []) => list.every((item) => item !== '')

  if (success) {
		return (
      <section className='page__order'>
        <div className='section__content'>
          <div className='cart' style={{ minHeight: 550 }}>
            <div>
              <h2 style={{ textAlign: 'center' }}>Ваше замовлення <br /> №{number} <br /> прийнято</h2>
              <div style={{ textAlign: 'center', fontSize: 16 }}>
                Наш менеджер зв'яжеться з вами за кілька хвилин
              </div>
            </div>
          </div>
        </div>
      </section>
		)
	}

  const department = np.find(item => item.Description === desc) || {}
  const addressProps = deliveryMethod === DELIVERY_METHODS.department
    ? {
      label: 'Номер поштового відділення',
      placeholder: 'Номер відділення',
    }
    : {
      label: 'Адреса',
      placeholder: 'Адреса',
    }

  return (
    <section className='page__order'>
      <div className='section__content'>
        <div className='page__order__contacts page__order-section'>
          <div className='page__order-section__title'>
            <span
              className={`page__order-section__number ${isCompletedSection([name, lastName, phone]) ? 'page__order-section__number--active' : ''}`}
            >
              1
            </span>
            <span>Контактні дані</span>
          </div>
          <div className='page__order__contacts-fields'>
            <TextField
              placeholder='Введіть імя'
              label="Імя"
              onChange={(e) => updateState({ name: e.target.value })}
            />
            <TextField
              placeholder='Введіть прізвище'
              label="Прізвище"
              onChange={(e) => updateState({ lastName: e.target.value })}
            />
          </div>
          <div className='page__order__contacts-fields'>
            <TextField
              placeholder='+38 (0 - -) - - - - - - -'
              label="Номер телефону"
              onChange={(e) => {
                updateState({ phone: phone ? e.target.value : `380${e.target.value}` })
                setFieldTouched('phone', true)
              }}
              isInvalid={touched.phone && !phone.match(UKRAINE_PHONE_NUMBER_REG_EXP)}
              errorText='Не валідний телефон'
            />
            <TextField
              placeholder='Введіть email'
              label="Email"
              onChange={(e) => {
                updateState({ email: e.target.value })
                setFieldTouched('email', true)
              }}
              isInvalid={touched.email && !email.match(EMAIL_REG_EXP)}
              errorText='Не валідний email'
            />
          </div>
        </div>

        <div className='page__order__method-of-receipt page__order-section'>
          <div className='page__order-section__title'>
            <span
              className={
                `page__order-section__number
                ${isCompletedSection([opl, city, desc])
                  ? 'page__order-section__number--active'
                  : ''
                }
              `}
            >
              2
            </span>
            <span>Спосіб отримання</span>
          </div>
          <div className='flex-container--between flex-container--wrap'>
            <div className='page__order__method-of-receipt__left'>
              <div>Служба доставки:</div>
              <Form.Check
                id={METHOD_OF_RECEIPT_KEYS.novaPoshta}
                checked={opl === METHOD_OF_RECEIPT_KEYS.novaPoshta}
                type='radio'
                value={opl}
                label={(
                  <>
                    <img src={NovaPoshtaIcon} width={32} height={32} alt="" />
                    <div className='page__order__method-of-receipt__left-delivery'>
                      <div className='page__order__payment-methods__content__sub-title'>Доставка Новою поштою</div>
                      <div className='page__order__payment-methods__content__title'>від 100 грн.</div>
                    </div>
                  </>
                )}
                onChange={() => updateState({ opl: METHOD_OF_RECEIPT_KEYS.novaPoshta })}
              />

              <Form.Check
                id={METHOD_OF_RECEIPT_KEYS.meest}
                checked={opl === METHOD_OF_RECEIPT_KEYS.meest}
                type='radio'
                value={opl}
                label={(
                  <>
                    <img src={MeestIcon} width={32} height={32} alt="" style={{ objectFit: 'none' }} />
                    <div className='page__order__method-of-receipt__left-delivery'>
                      <div className='page__order__payment-methods__content__sub-title'>Доставка Meest</div>
                      <div className='page__order__payment-methods__content__title'>від 90 грн.</div>
                    </div>
                  </>
                )}
                onChange={() => updateState({ opl: METHOD_OF_RECEIPT_KEYS.meest })}
              />

              <Form.Check
                id=''
                type='radio'
                checked={opl === METHOD_OF_RECEIPT_KEYS.delivery}
                value={opl}
                label={(
                  <>
                    <img src={UkrPoshta} width={32} height={32} alt="" style={{ objectFit: 'scale-down' }} />
                    <div className='page__order__method-of-receipt__left-delivery'>
                      <div className='page__order__payment-methods__content__sub-title'>Доставка Delivery</div>
                      <div className='page__order__payment-methods__content__title'>від 50 грн.</div>
                    </div>
                  </>
                )}
                onChange={() => updateState({ opl: METHOD_OF_RECEIPT_KEYS.delivery })}
              />
            </div>

            <div className='page__order__method-of-receipt__right'>
              <SelectField
                label='Спосіб доставки'
                theme={{ width: '100%', height: 55, borderRadius: 10 }}
                options={DELIVERY_METHODS_OPTIONS}
                value={DELIVERY_METHODS_OPTIONS.find(({ value }) => value === deliveryMethod)}
                onChange={(option) => updateState({ deliveryMethod: option.value })}
              />
              <TextField
                label='Вкажіть місто'
                placeholder='Введіть місто'
                onChange={e => {
                  if (cities.find(el => el.Description === e.target.value)) {
                    fetchWearehouses(e.target.value);
                  }
                  updateState({ city: e.target.value })
                }}
                value={city}
                data={cities.map(el => el.Description)}
              />
              {opl === METHOD_OF_RECEIPT_KEYS.novaPoshta && deliveryMethod === DELIVERY_METHODS.department
                ? (
                  <SelectField
                    id='department'
                    label='Номер поштового відділення'
                    theme={{ width: '100%', height: 55, borderRadius: 10 }}
                    placeholder='Номер відділення'
                    options={np.map(el => ({ label: el.Description, value: el.Description }))}
                    value={Object.keys(department).length ? { label: department.Description, value: department.Description } : null}
                    onChange={(option) => updateState({ desc: option.value })}
                  />
                ) 
                : (
                  <TextField
                    {...addressProps}
                    onChange={(e) => updateState({ desc: e.targe.value })}
                  />
                )
              }
            </div>
          </div>
        </div>

        <div className='page__order__payment-methods page__order-section'>
          <div className='page__order-section__title'>
            <span
              className={`page__order-section__number ${isCompletedSection([dost]) ? 'page__order-section__number--active' : ''}`}
            >
              3
            </span>
            <span>Спосіб оплати</span>
          </div>
          <div className='page__order__payment-methods__content'>
            <div className='page__order-section'>
              <Form.Check
                id={PAYMENT_METHODS.card}
                checked={dost === PAYMENT_METHODS.card}
                type='radio'
                label={(
                  <>
                    <img src="https://img.icons8.com/pastel-glyph/32/baabb2/bank-cards.png" alt="" />
                    <div className='page__order__payment-methods__content__title'>Онлайн</div>
                    <div className='page__order__payment-methods__content__sub-title'>Картами Visa, MasterCard</div>
                  </>
                )}
                value={dost}
                onChange={() => updateState({ dost: PAYMENT_METHODS.card })}
              />
            </div>

            <div className='page__order-section'>
              <Form.Check
                id={PAYMENT_METHODS.cash}
                checked={dost === PAYMENT_METHODS.cash}
                type='radio'
                label={(
                  <>
                    <img src="https://img.icons8.com/external-kiranshastry-solid-kiranshastry/32/baabb2/external-wallet-man-accessories-kiranshastry-solid-kiranshastry.png" alt="" />
                    <div className='page__order__payment-methods__content__title'>Готівкою при отриманні</div>
                    <div className='page__order__payment-methods__content__sub-title'>Валюта - гривня</div>
                  </>
                )}
                value={dost}
                onChange={() => updateState({ dost: PAYMENT_METHODS.cash })}
              />
            </div>
          </div>
        </div>

        <div className='page-order__purchase flex-container--end'>
          <div className='page-order__purchase-text'>
            <div>Нажимая на кнопку “Оформить заказ” вы</div>
            <div>соглашаетесь с политикой конфиденциальности</div>
          </div>
          <Button
            onClick={submit}
            disabled={submitDisabled}
          >
            Оформити замовлення
          </Button>
        </div>

      </div>
    </section>
  )
}

function mapStateToProps(state) {
	return {
		cart: state.cart,
		user: state.user
	}
}
function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		login,
		addToCart,
		removeFromCart,
		changeCount,
    clearCart,
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Order)
